import { render, staticRenderFns } from "./TemplateClient.vue?vue&type=template&id=f09c4c7c"
import script from "./TemplateClient.vue?vue&type=script&lang=js"
export * from "./TemplateClient.vue?vue&type=script&lang=js"
import style0 from "./TemplateClient.vue?vue&type=style&index=0&id=f09c4c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports